import { getCityListApi, getList, getLocationList, getLocation, getGroupList, getColumnList, setColumnList, getVehicleGroup, moveGroup, moveCurrentGroup, addGroup, updateGroup, delGroupApi, setRemark, getFence, getTrajectory } from '@/api/risk/realtime';

const successCode = 0;

const realtimeControl = {
  name: 'realtimeControl',
  namespaced: true,
  actions: {
    getCityList(state, params) {
      return new Promise((resolve, reject) => {
        getCityListApi(params)
          .then((response) => {
            const { data, code, msg } = response;
            if (!data) {
              reject('暂无数据');
            }
            if (code === successCode) {
              resolve(data);
            } else {
              reject(msg);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 列表
    List(state, params) {
      return new Promise((resolve, reject) => {
        getList(params)
          .then((response) => {
            const { data, code, msg } = response;
            if (!data) {
              reject('暂无数据');
            }
            if (code === successCode) {
              resolve(data);
            } else {
              reject(msg);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 地图定位信息列表
    GetLocationList(state, params) {
      return new Promise((resolve, reject) => {
        getLocationList(params)
          .then((response) => {
            const { data, code, msg } = response;
            if (!data) {
              reject('暂无数据');
            }
            if (code === successCode) {
              resolve(data);
            } else {
              reject(msg);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 车辆定位信息
    GetLocation(state, params) {
      return new Promise((resolve, reject) => {
        getLocation(params)
          .then((response) => {
            const { data, code, msg } = response;
            if (!data) {
              reject('暂无数据');
            }
            if (code === successCode) {
              resolve(data);
            } else {
              reject(msg);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 车辆电子围栏
    GetFence(state, params) {
      return new Promise((resolve, reject) => {
        getFence(params)
          .then((response) => {
            const { data, code, msg } = response;
            if (!data) {
              reject('暂无数据');
            }
            if (code === successCode) {
              resolve(data);
            } else {
              reject(msg);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 获取分组列表
    GetGroupList(state, params) {
      return new Promise((resolve, reject) => {
        getGroupList(params)
          .then((response) => {
            const { data, code, msg } = response;
            if (!data) {
              reject('暂无数据');
            }
            if (code === successCode) {
              resolve(data);
            } else {
              reject(msg);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 获取某个车辆分组列表
    GetVehicleGroup(state, params) {
      return new Promise((resolve, reject) => {
        getVehicleGroup(params)
          .then((response) => {
            const { data, code, msg } = response;
            if (!data) {
              reject('暂无数据');
            }
            if (code === successCode) {
              resolve(data);
            } else {
              reject(msg);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 获得自定义列
    GetColumnList(state, params) {
      return new Promise((resolve, reject) => {
        getColumnList(params)
          .then((response) => {
            const { data, code, msg } = response;
            if (!data) {
              reject('暂无数据');
            }
            if (code === successCode) {
              resolve(data);
            } else {
              reject(msg);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 获得历史轨迹
    GetTrajectory(state, params) {
      return new Promise((resolve, reject) => {
        getTrajectory(params)
          .then((response) => {
            const { data, code, msg } = response;
            if (!data) {
              reject('暂无数据');
            }
            if (code === successCode) {
              resolve(data);
            } else {
              reject(msg);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 设置自定义列
    SetColumnList(state, params) {
      return new Promise((resolve, reject) => {
        setColumnList(params)
          .then((response) => {
            const { code, msg } = response;
            const data = {
              success: true,
            };
            if (code === successCode) {
              resolve(data);
            } else {
              reject(msg);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 移动分组
    MoveGroup(state, params) {
      return new Promise((resolve, reject) => {
        moveGroup(params)
          .then((response) => {
            const { code, msg } = response;
            const data = {
              success: true,
            };
            if (code === successCode) {
              resolve(data);
            } else {
              reject(msg);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    MoveCurrentGroup(state, params) {
      return new Promise((resolve, reject) => {
        moveCurrentGroup(params)
          .then((response) => {
            const { code, msg } = response;
            const data = {
              success: true,
            };
            if (code === successCode) {
              resolve(data);
            } else {
              reject(msg);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 新增分组
    AddGroup(state, params) {
      return new Promise((resolve, reject) => {
        addGroup(params)
          .then((response) => {
            const { code, msg } = response;
            const data = {
              success: true,
            };
            if (code === successCode) {
              resolve(data);
            } else {
              reject(msg);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 编辑分组
    UpdateGroup(state, params) {
      return new Promise((resolve, reject) => {
        updateGroup(params)
          .then((response) => {
            const { code, msg } = response;
            const data = {
              success: true,
            };
            if (code === successCode) {
              resolve(data);
            } else {
              reject(msg);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 删除分组
    DelGroup(state, params) {
      return new Promise((resolve, reject) => {
        delGroupApi(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 车辆备注信息编辑
    SetRemark(state, params) {
      return new Promise((resolve, reject) => {
        setRemark(params)
          .then((response) => {
            const { code, msg } = response;
            const data = {
              success: true,
            };
            if (code === successCode) {
              resolve(data);
            } else {
              reject(msg);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};

export default realtimeControl;
